import React from 'react';
import { useTranslation } from 'react-i18next';
import { Heading } from '@amzn/storm-ui';
import CustomAlert from '../../../UiComponentsLibrary/CustomAlert';

import { PageContainer, ContentWrapper } from './UserUnauthorized.styles';

const UserUnauthorized = () => {
  const { t } = useTranslation();

  return (
    <PageContainer direction="column">
      <ContentWrapper direction="column">
        <Heading>{`${t('user-unauthorized-access-heading')}`}</Heading>
        <CustomAlert
          variant="error"
          alertMessage={`${t('user-unauthorized-access-message')}`}
        />
      </ContentWrapper>
    </PageContainer>
  );
};

export default UserUnauthorized;
